import React, { useState } from 'react';
import Login from './Login';
import SignUp from './SignUp';
import ForgotPassword from './ForgotPassword';
import { Box, Container } from '@mui/material';

type AuthView = 'login' | 'signup' | 'forgotPassword';

const AuthPage: React.FC = () => {
  const [currentView, setCurrentView] = useState<AuthView>('login');

  const handleSwitchToLogin = () => {
    setCurrentView('login');
  };

  const handleSwitchToSignUp = () => {
    setCurrentView('signup');
  };

  const handleSwitchToForgotPassword = () => {
    setCurrentView('forgotPassword');
  };

  return (
    <Container maxWidth={false} sx={{ display: 'flex', minHeight: '100vh', bgcolor: 'background.default' }}>
      <Box sx={{ width: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
        {currentView === 'login' && (
          <Login 
            onSwitchToSignUp={handleSwitchToSignUp} 
            onSwitchToForgotPassword={handleSwitchToForgotPassword} 
          />
        )}
        
        {currentView === 'signup' && (
          <SignUp 
            onSwitchToLogin={handleSwitchToLogin}
          />
        )}
        
        {currentView === 'forgotPassword' && (
          <ForgotPassword 
            onSwitchToLogin={handleSwitchToLogin} 
          />
        )}
      </Box>
    </Container>
  );
};

export default AuthPage; 